import mailCollapsePanel from './components/mailCollapsePanel.vue';
import { sceneVariableResource, allMessageList } from './request';
export default {
  data() {
    return {
      activeKey: 'INTERNAL_MAIL',
      sceneListId: '',
      variables: {},
      messageLists: []
    };
  },
  components: {
    mailCollapsePanel
  },
  created() {
    this.sceneListId = this.$route.params.id;
    this.getVariableResouce();
    this.getMessages();
  },
  methods: {
    getMessages() {
      allMessageList({}).then(res => {
        this.messageLists = res;
      });
    },
    getVariableResouce() {
      sceneVariableResource({
        sceneListId: this.sceneListId
      }).then(res => {
        if (res) {
          this.variables = res;
        }
      });
    },
    tabChange(key) {
      this.activeKey = key;
    }
  }
};